import { isDate, toDate, isValid } from 'date-fns';

const format = (date, mask = 'dd.mm.yy') => {
  if (!date) {
    return undefined;
  }

  const value = isDate(date) ? date : toDate(date);

  if (!isValid(value)) {
    return undefined;
  }

  const pad = v => String(v).length === 1 ? `0${v}` : v.toString();

  return mask.replace('dd', pad(value.getDate())).replace('mm', pad(value.getMonth() + 1)).replace('yy', String(value.getFullYear()).slice(2));
};
const parseFromCustomString = (date = '', mask = 'dd.mm.yy') => {
  if (!date || !date.length) {
    return undefined;
  }

  const sanitizedMask = mask.split(/[^dmy]/);
  const dd = sanitizedMask.findIndex(x => x === 'dd');
  const mm = sanitizedMask.findIndex(x => x === 'mm');
  const yy = sanitizedMask.findIndex(x => x === 'yy' || x === 'yyyy');
  let day;
  let month;
  let year;

  const getFullYear = y => {
    if (y && y.length === 2) {
      const z = Number.parseInt(y, 10);
      return z > 50 ? `19${y}` : `20${y}`;
    }

    return y;
  };

  const inputParts = date.split(/\D/);

  if (inputParts.length === 1) {
    const fullDate = inputParts[0];
    const unseparatedMask = mask.replace(/[^dmy]/g, '');
    day = fullDate.slice(unseparatedMask.indexOf('d'), unseparatedMask.lastIndexOf('d') + 1);
    month = fullDate.slice(unseparatedMask.indexOf('m'), unseparatedMask.lastIndexOf('m') + 1);
    year = getFullYear(fullDate.slice(unseparatedMask.indexOf('y'), unseparatedMask.lastIndexOf('y') + 3)); // account for full years
  } else {
    day = inputParts[dd];
    month = inputParts[mm];
    year = getFullYear(inputParts[yy]);
  }

  day = Number.parseInt(day, 10);
  month = Number.parseInt(month, 10);
  year = Number.parseInt(year, 10);
  const currentDate = new Date();
  return new Date(
  /* year */
  Object.is(year, NaN) ? currentDate.getFullYear() : year,
  /* month */
  Object.is(month, NaN) ? currentDate.getMonth() : month - 1, // months are zero based in javascript, so subtract a day

  /* day */
  Object.is(day, NaN) ? currentDate.getDate() : day,
  /* hours */
  12,
  /* minutes */
  0 // set to midday to avoid UTC offset causing dates to be mismatched server side
  );
};
const parseFromISOString = date => {
  const tempDate = new Date(date);
  return isValid(tempDate) ? parseFromCustomString(format(new Date(date))) : undefined;
};

export { format, parseFromCustomString, parseFromISOString };
//# sourceMappingURL=date.js.map
